import React from 'react';

/**
 * PART 3, раздел 2: удаление — отдельное разрушительное действие, confirm
 * обязателен. Native window.confirm здесь не годится: он не отличает удаление
 * от отключения и не показывает ошибку бэкенда, из-за чего пользователь может
 * счесть неудачный DELETE успешным.
 */
const ConfirmRuleDeleteModal = ({ ruleName, busy = false, error = '', onConfirm, onCancel }) => (
  <>
    <div className="vio-modal-overlay" onClick={busy ? undefined : onCancel} />
    <div className="vio-modal" role="dialog" aria-modal="true" aria-label="Удалить правило">
      <h2 className="vio-modal-title">Удалить правило?</h2>
      <p className="vio-modal-text">
        Правило «{ruleName}» будет удалено. Активные события этого правила
        завершатся автоматически.
      </p>

      <div className="vio-modal-warning">
        Удаление отличается от отключения. Если правило может понадобиться снова —
        используйте «Деактивировать».
      </div>

      {error && <p className="vio-field-error">{error}</p>}

      <div className="vio-modal-actions">
        <button type="button" className="vio-btn" disabled={busy} onClick={onCancel}>
          Отмена
        </button>
        <button type="button" className="vio-btn vio-btn--danger" disabled={busy} onClick={onConfirm}>
          {busy ? 'Удаляем…' : 'Да, удалить'}
        </button>
      </div>
    </div>
  </>
);

export default ConfirmRuleDeleteModal;
